import { useCallback, useState } from 'react';
import { UAlert, uploadFile } from 'utils';

export const useDrop = (
  insertImages: (markdownImage: string) => void
): [(acceptedFiles: File[]) => void, boolean, string[]] => {
  const [imageUrls, setImageUrls] = useState([] as any);
  const [uploading, setUploading] = useState(false);

  const onDrop = useCallback((acceptedFiles: File[]) => {
    // Do something with the files
    setUploading(true);
    const imageUrlPromises = acceptedFiles.map(async (file: File) => {
      try {
        // Do whatever you want with the file contents
        const binaryStr = await readFileAsync(file);
        if (binaryStr == null || !(binaryStr instanceof ArrayBuffer))
          throw new Error('Error processing file');

        const url = await uploadFile(binaryStr, file.type);
        insertImages(`![your image will appear here](${url})`);
        return url;
      } catch (err) {
        UAlert(`Error uploading image: ${err.message}`);
        setUploading(false);
      }
      const allImageUrls = await Promise.all(imageUrlPromises);
      setImageUrls(allImageUrls);
      setUploading(false);
    });
  }, []);
  return [onDrop, uploading, imageUrls];
};

function readFileAsync(file: File): Promise<string | ArrayBuffer | null> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onabort = () => reject(new Error('File reading was aborted'));
    reader.onerror = (err) => reject(err);
    reader.readAsArrayBuffer(file);
  });
}
